import React from "react"
import tw from "twin.macro"
import { Check } from "react-feather"
import styled from "@emotion/styled"

interface Props extends React.HTMLProps<HTMLInputElement> {
  className?: string
}

const Checkbox: React.FC<Props> = ({ className, ...rest }) => {
  return (
    <StyledCheckbox.Wrapper className={className}>
      <StyledCheckbox.Input {...rest} type="checkbox" />
      <StyledCheckbox.Check />
    </StyledCheckbox.Wrapper>
  )
}

const StyledCheckbox = {
  Wrapper: styled.div`
    ${tw`relative bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-fresh-green`}

    input:checked + svg {
      display: block;
    }
  `,
  Input: tw.input`opacity-0 absolute w-full h-full`,
  Check: tw(Check)`hidden w-4 h-4 text-green-500 pointer-events-none`,
}

export default Checkbox
